import { RootState } from "../../../store";
import { type State } from "./activeCourse.state";

export const getActiveCourse = (state: RootState): State => state.activeCourse;
